import { useState } from 'react'
import { useSupabaseClient } from 'src/api/supabase'
import { STORAGE_BUCKETS, STORAGE_PATHS } from './consts'
import { addImageUrl } from './utils'

export const useImageUpload = (
  bucket: string,
  onUploadComplete: (url: string) => void
) => {
  const supabase = useSupabaseClient()
  const [isUploading, setIsUploading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleImageUpload = async (file: File) => {
    try {
      setIsUploading(true)
      setError(null)
      const fileExt = file.name.split('.').pop()
      const fileName = `${Math.random()}.${fileExt}`
      const filePath = `${STORAGE_PATHS.PRODUCT_COLORS}/${fileName}`

      const { error: uploadError } = await supabase.storage
        .from(bucket)
        .upload(filePath, file)

      if (uploadError) throw uploadError

      const {
        data: { publicUrl },
      } = supabase.storage.from(bucket).getPublicUrl(filePath)

      onUploadComplete(publicUrl)
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to upload image'
      console.error('Error uploading image:', err)
      setError(errorMessage)
    } finally {
      setIsUploading(false)
    }
  }

  return { handleImageUpload, isUploading, error }
}

export const useProductImageUpload = (
  imageUrls: string,
  setImageUrls: (urls: string) => void
) => {
  const onUploadComplete = (url: string) => {
    setImageUrls(addImageUrl(imageUrls, url))
  }

  const { handleImageUpload, isUploading, error } = useImageUpload(
    STORAGE_BUCKETS.PRODUCT_IMAGES,
    onUploadComplete
  )

  return { handleImageUpload, isUploading, error }
}

export const useIllustrationImageUpload = (
  newImageUrls: string,
  setNewImageUrls: (urls: string) => void
) => {
  const onUploadComplete = (url: string) => {
    setNewImageUrls(addImageUrl(newImageUrls, url))
  }

  const { handleImageUpload, isUploading, error } = useImageUpload(
    STORAGE_BUCKETS.ILLUSTRATION_LOGOS,
    onUploadComplete
  )

  return { handleImageUpload, isUploading, error }
}

